var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    "+_vm._s(_vm.previousYears)+"\n    "),_c('ul',_vm._l((_vm.previousYears),function(year,i){return _c('li',[_vm._v("\n            "+_vm._s(year)+"\n        ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }